var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardProductType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C8.34315 13 7 14.3431 7 16V36C7 37.6569 8.34315 39 10 39H12C12.5523 39 13 38.5523 13 38C13 37.4477 12.5523 37 12 37H10C9.44772 37 9 36.5523 9 36V16C9 15.4477 9.44771 15 10 15H44C44.5523 15 45 15.4477 45 16V19C45 19.5523 45.4477 20 46 20C46.5523 20 47 19.5523 47 19V16C47 14.3431 45.6569 13 44 13H10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 25C40.567 25 39 26.567 39 28.5C39 30.433 40.567 32 42.5 32H45.5C47.433 32 49 30.433 49 28.5C49 26.567 47.433 25 45.5 25H42.5ZM41 28.5C41 27.6716 41.6716 27 42.5 27H45.5C46.3284 27 47 27.6716 47 28.5C47 29.3284 46.3284 30 45.5 30H42.5C41.6716 30 41 29.3284 41 28.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21C16.3431 21 15 22.3431 15 24V44C15 45.6569 16.3431 47 18 47H50C51.6569 47 53 45.6569 53 44V24C53 22.3431 51.6569 21 50 21H18ZM17 24C17 23.4477 17.4477 23 18 23H50C50.5523 23 51 23.4477 51 24V37H17V24ZM17 39H51V41H17V39ZM17 43H51V44C51 44.5523 50.5523 45 50 45H18C17.4477 45 17 44.5523 17 44V43Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardProductType);
export default __webpack_public_path__ + "static/media/credit-card-product-type.16be5a5c.svg";
export { ForwardRef as ReactComponent };